const SEO = [
    {
        page: "home",
        description:
            "Expert hair salon in Falls Church, VA specializing in women's haircuts, hair coloring, highlights & balayage. Serving McLean, Vienna, Reston, Tysons Corner, Fairfax County & Northern Virginia. Book your haircut, color or highlights appointment near you today!",
        keywords: [
            // General "near me" searches
            "haircut near me",
            "women's haircut near me",
            "hair salon near me",
            "highlights near me",
            "balayage near me",
            "hair color near me",
            "beauty salon near me",
            // Women's haircut - all locations
            "women's haircut Falls Church",
            "women's haircut McLean",
            "women's haircut Tysons",
            "women's haircut Tysons Corner",
            "women's haircut Northern Virginia",
            "haircut Falls Church VA",
            "haircut McLean VA",
            "haircut Tysons VA",
            "best haircut Falls Church",
            "best haircut McLean",
            "best haircut Tysons",
            // Highlights - all locations
            "highlights Falls Church",
            "highlights McLean",
            "highlights Tysons",
            "highlights Tysons Corner",
            "highlights Falls Church VA",
            "highlights McLean VA",
            "highlights Tysons VA",
            "highlights Northern Virginia",
            "hair highlights near me",
            "best highlights Falls Church",
            "best highlights McLean",
            "best highlights Tysons",
            // Balayage - all locations
            "balayage Falls Church",
            "balayage McLean",
            "balayage Tysons",
            "balayage Tysons Corner",
            "balayage Falls Church VA",
            "balayage McLean VA",
            "balayage Tysons VA",
            "balayage Northern Virginia",
            "best balayage Falls Church",
            "best balayage McLean",
            "best balayage Tysons",
            // Hair salon - all locations
            "hair salon Falls Church",
            "hair salon McLean",
            "hair salon Tysons",
            "hair salon Tysons Corner",
            "hair salon Falls Church VA",
            "hair salon McLean VA",
            "hair salon Tysons VA",
            "hair salon Northern Virginia",
            "best hair salon Falls Church",
            "best hair salon McLean",
            "best hair salon Tysons",
            // Additional Fairfax County & nearby cities
            "haircut Vienna VA",
            "haircut Reston VA",
            "women's haircut Vienna",
            "women's haircut Reston",
            "haircut Fairfax County",
            "highlights Vienna",
            "highlights Reston",
            "highlights Vienna VA",
            "highlights Reston VA",
            "highlights Fairfax County",
            "hair salon Vienna VA",
            "hair salon Reston VA",
            "hair salon Fairfax County",
            // Color services
            "hair color Falls Church",
            "hair color McLean",
            "hair color Tysons",
            "hair color Vienna",
            "hair color Reston",
            "hair color Fairfax County",
            "hair coloring Falls Church",
            "hair coloring McLean",
            "hair coloring Vienna",
            "hair coloring Reston",
            "color correction Falls Church",
            "color correction McLean",
            "color correction Tysons",
            // Specialty terms
            "Pasmo salon",
            "Leesburg Pike hair salon",
            "Asian hair specialist Northern Virginia",
            "precision haircuts Northern VA",
        ],
    },
    {
        page: "about",
        description:
            "Meet Anna, an award-winning hair stylist and balayage specialist in Falls Church, VA. Expert in creating custom balayage, highlights, and color corrections. Specialized in Asian hair coloring techniques for natural-looking results.",
        keywords: [
            "balayage specialist Anna",
            "professional colorist Falls Church",
            "Asian hair balayage expert",
            "highlights specialist VA",
            "color correction expert",
            "balayage master stylist",
            "hair painting specialist",
            "Pasmo founder",
            "top hair colorist VA",
            "certified balayage expert"
        ],
    },
    {
        page: "services",
        description:
            "Professional hair services in Falls Church, McLean, Vienna, Reston & Tysons. Women's haircuts, hair coloring, highlights, balayage & color correction. Expert cuts starting at $85, balayage at $200. Serving Fairfax County & Northern Virginia. Book your haircut, color or highlights near you!",
        keywords: [
            // Service + location combinations
            "women's haircut Falls Church",
            "women's haircut McLean", 
            "women's haircut Tysons",
            "women's haircut Vienna",
            "women's haircut Reston",
            "haircut Falls Church",
            "haircut McLean",
            "haircut Tysons",
            "haircut Vienna",
            "haircut Reston",
            "haircut Fairfax County",
            "highlights Falls Church",
            "highlights McLean",
            "highlights Tysons",
            "highlights Vienna",
            "highlights Reston",
            "highlights Fairfax County",
            "balayage Falls Church",
            "balayage McLean",
            "balayage Tysons",
            "balayage Vienna",
            "balayage Reston",
            "color correction Falls Church",
            "color correction McLean",
            "color correction Tysons",
            "color correction Vienna",
            "color correction Reston",
            "keratin treatment Falls Church",
            "keratin treatment McLean",
            "keratin treatment Tysons",
            "keratin treatment Vienna",
            "keratin treatment Reston",
            // "Near me" searches
            "haircut near me",
            "women's haircut near me",
            "highlights near me",
            "balayage near me",
            "hair salon near me",
            // Men's services
            "men's haircut Falls Church",
            "men's haircut McLean",
            "men's haircut Tysons",
            "men's haircut Vienna",
            "men's haircut Reston",
            // Best/top searches
            "best haircut Falls Church",
            "best haircut McLean",
            "best haircut Tysons",
            "best haircut Vienna",
            "best haircut Reston",
            "best highlights Falls Church",
            "best highlights McLean",
            "best highlights Tysons",
            "best highlights Vienna",
            "best highlights Reston",
            "best balayage Northern Virginia",
            // General
            "hair services Falls Church VA",
            "hair services McLean VA",
            "hair services Tysons VA",
            "hair services Vienna VA",
            "hair services Reston VA",
            "hair services Fairfax County VA",
            "Falls Church hair salon services",
            "Vienna hair salon services",
            "Reston hair salon services",
            "Fairfax County hair salon services",
            "professional hair salon Northern VA",
        ],
    },
    {
        page: "projects",
        description:
            "View stunning hair transformations at Pasmo salon in Falls Church. Before & after gallery featuring balayage, highlights, color correction & precision cuts. See why we're Northern Virginia's top-rated hair salon. Book your transformation today!",
        keywords: [
            "hair transformation gallery",
            "before and after hair color",
            "balayage results Tysons",
            "hair color transformation",
            "best haircuts Falls Church",
            "premium hair services VA",
            "hair makeover specialist",
            "blonde specialist Tysons",
            "Asian hair transformation",
            "wedding hair specialist VA"
        ],
    },
    {
        page: "articles",
        description:
            "Expert hair care tips from Pasmo salon in Falls Church. Learn about balayage maintenance, color care, styling techniques & hair health. Professional advice from master colorist Anna for beautiful hair between salon visits.",
        keywords: [
            "professional hair care tips",
            "hair maintenance guide",
            "hair color maintenance",
            "salon styling tutorials",
            "hair treatment advice",
            "hair care blog Tysons",
            "hair trend updates",
            "hair health tips",
            "color protection advice",
            "styling tips for Asian hair"
        ],
    },
    {
        page: "contact",
        description:
            "Book your haircut, hair color or highlights appointment at Pasmo - 7121 Leesburg Pike, Falls Church, VA 22043. Women's haircuts, highlights, balayage & color services. Convenient to McLean, Vienna, Reston, Tysons Corner, Fairfax County & Northern Virginia. Book online today!",
        keywords: [
            "book haircut Falls Church",
            "book haircut McLean",
            "book haircut Tysons",
            "book highlights Falls Church",
            "book highlights McLean",
            "book highlights Tysons",
            "book balayage Falls Church",
            "book balayage McLean",
            "book balayage Tysons",
            "hair salon appointment Falls Church",
            "hair salon appointment McLean",
            "hair salon appointment Tysons",
            "hair appointment near me",
            "salon near me",
            "Pasmo location",
            "Leesburg Pike salon",
            "Falls Church salon",
            "hair salon McLean Virginia",
            "hair salon Tysons Corner"
        ],
    },
];

export default SEO;
